import { ParametersModel, ParametersModelAPI } from '../../../../models';

export const getparametersApplicationAdapter = (
    responseAPI: ParametersModelAPI[]
): ParametersModel[] => {
    return responseAPI
        ? responseAPI.map((parameter) => {
              return {
                  id: parameter.id,
                  name: parameter.name,
                  description: parameter.description,
                  observation: parameter.observation,
                  dataTypeId: parameter.dataTypeId,
                  value: parameter.value,
              };
          })
        : [];
};
